/* eslint-disable linebreak-style */
import {
  put, call, all, takeLatest,
} from 'redux-saga/effects';
import { notification } from 'antd';
import { setAnalysis, setAnalysisFailure } from '../state/action/analysisAction';
import {
  FETCH_ANALYSIS
} from '../state/types';
import fetch from '../services/fetch';

import { BASE_URL } from '../config';

function* getAnalysis() {
  try {
    const res = yield fetch(`${BASE_URL}/analysis`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });
    if (res.status === 403) {
      throw new Error('Unauthorized');
    }
    const response = yield res.json();
    yield put(setAnalysis({ response }));
  } catch (error) {
    yield put(setAnalysisFailure());
    notification.error({
      message: 'There was a problem fetching the analysis details.',
      description: `${error}`,
    });
  }
}

function* analysisWatcher() {
  yield takeLatest(FETCH_ANALYSIS, getAnalysis);
}

function* analysisSagas() {
  yield all([
    call(analysisWatcher),
  ]);
}

export default analysisSagas;
